import type { PageMeta } from '../../../lib/permissions/pageMeta'
import GoodsInTransitPage from '../GoodsInTransitPage'

export const pageMeta: PageMeta = {
  key: 'buy.in_transit',
  label: 'Goods in Transit',
  module: 'Trading',
  section: 'Buy',
  description: 'Track purchase orders in transit',
  defaultPermissions: {
    owner: 'edit', admin: 'edit', manager: 'edit',
    accountant: 'view', cashier: 'none', viewer: 'view',
  },
  hasVisibility: true,
  ownerColumn: 'created_by',
}

export default function BuyInTransitTab() {
  return <GoodsInTransitPage />
}
